// Module
var code = "<input type=\"text\" post-validation>";
// Exports
export default code;